export default "__VITE_ASSET__BotGIgc7__"